if (!customElements.get('collapsible-tab')) {
	class CollapsibleTab extends HTMLElement {
		constructor() {
			super()
			// holder for bound event so we can remove it on destroy
			this._onTriggerClick = null
		}

		connectedCallback() {
			this.init()
		}

		disconnectedCallback() {
			this.destroy()
		}

		init() {
			const destroy = this.dataset.destroy === 'true'
			if (destroy) return

			this.setDefaultData();
			this.attachEvents()

			// default open state handling
			try {
				var isDevPage = document.querySelectorAll('.collapsible__item--dev');
				//collapsible__item--dev
				if (!isDevPage) {
					const parent = this.closest('[data-collapsible-parent]')
					let groupItems = []
					if (parent) {
						groupItems = Array.from(parent.querySelectorAll('collapsible-tab'))
					} else {
						// no parent, treat all collapsible-tabs in document as group
						groupItems = Array.from(document.querySelectorAll('collapsible-tab'))
					}

					// if this is the first element in the group and no items in the group are explicitly set to open, only show highlight effect
					if (groupItems.length && groupItems[0] === this) {
						const anyOpen = groupItems.some(item => item.getAttribute && item.getAttribute('open') === 'true')
						if (!anyOpen) {
							// on initial page load, the first title shows a "hover/bold" visual effect to indicate it is the default item
							// but does not expand the content, user clicks to expand
							try {
								this.ensureDefaultHover()
							} catch (e) {
								// ignore
							}
						}
					}
				}
			} catch (e) {
				// fail-safe: do not block subsequent logic if error occurs
				console && console.error && console.error(e)
			}
			if (this.getAttribute('open') === 'true') {
				this.selected = true
				this.classList.add(this.expandedClass, this.selectedClass)
				this.setExpandedAria()
				this.fire("tabOpened")
				window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this)
			} else {
				this.content.style.height = this.collapsedHeight
				this.classList.add(this.collapsedClass)
				this.setCollapsedAria()
			}
			this.content.removeAttribute('hidden')
		}

		transitionendEventName() {
			let i,
				el = document.createElement('div'),
				transitions = {
					'transition': 'transitionend',
					'OTransition': 'otransitionend',
					'MozTransition': 'transitionend',
					'WebkitTransition': 'webkitTransitionEnd'
				}

			for (i in transitions) {
				if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
					return transitions[i]
				}
			}
		}

		expand() {
			const resetHeight = (ev) => {
				if (ev.target !== this.content) return
				this.content.removeEventListener(this.transitionendevent, bindEvent)

				if (!this.isOpen) return

				requestAnimationFrame(() => {
					this.content.style.transition = '0'
					this.content.style.height = 'auto'

					requestAnimationFrame(() => {
						this.content.style.height = null
						this.content.style.transition = null

						this.setExpandedAria()
						this.classList.add(this.expandedClass)
						this.trySetTabIndex(this.content, 0)

						this.fire("tabOpened")
						window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this)
					})
				})
			}

			const bindEvent = resetHeight.bind(this)
			this.content.addEventListener(this.transitionendevent, bindEvent)

			this.isOpen = true
			this.classList.remove(this.collapsedClass)
			this.content.style.height = this.content.scrollHeight + "px"
		}

		collapse() {
			const endTransition = (ev) => {
				if (ev.target !== this.content) return
				this.content.removeEventListener(this.transitionendevent, bindEvent)

				if (this.isOpen) return

				this.fire("elementClosed")
				window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this)
				this.setCollapsedAria()
				this.classList.add(this.collapsedClass)
				this.trySetTabIndex(this.content, -1)
			}

			const bindEvent = endTransition.bind(this)
			this.content.addEventListener(this.transitionendevent, bindEvent)

			this.isOpen = false
			this.classList.remove(this.expandedClass)

			requestAnimationFrame(() => {
				this.content.style.transition = '0'
				this.content.style.height = this.content.scrollHeight + "px"


				requestAnimationFrame(() => {
					this.content.style.transition = null
					this.content.style.height = this.collapsedHeight
				})
			})
		}

		open() {
			// When user manually opens, remove default highlight markers
			try { this._removeDefaultHoverFromGroup() } catch (e) { }
			this.selected = true
			this.classList.add(this.selectedClass)
			this.fire("elementSelected")
			window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_SELECTED`, this)
			this.expand()
			this.setAttribute('open', true)

			if (this.oneAtATime) {
				const parent = this.closest('[data-collapsible-parent]')
				if (parent) {
					const allItems = parent.querySelectorAll('collapsible-tab')
					if (allItems.length) {
						allItems.forEach(item => {
							if (item !== this && item.selected) {
								item.close()
							}
						})
					}
				}
			}
		}

		close() {
			// Ensure any default-hover markers are cleared when closing.
			try { this._removeDefaultHoverFromGroup() } catch (e) { }
			this.selected = false
			this.classList.remove(this.selectedClass)
			this.fire("elementUnselected")
			window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_UNSELECTED`, this)
			this.collapse()
			this.removeAttribute('open')
		}

		toggle(event) {
			if (event) {
				event.preventDefault()
			}

			// If already selected, clicking should toggle (close) the item.
			// Previous logic prevented closing the last-open item unless data-can-close-all was true.
			// For expected UX we close on click; if you want to preserve "always keep one open",
			// set data-can-close-all="false" handling explicitly or we can make this configurable.
			if (this.selected) {
				this.close()
				return
			}

			this.open()
		}

		trySetTabIndex(el, index) {
			const tappableElements = el.querySelectorAll(this.defaultElements)
			if (tappableElements) {
				tappableElements.forEach(e => {
					e.setAttribute('tabindex', index)
				})
			}
		}

		setExpandedAria() {
			this.trigger.setAttribute('aria-expanded', 'true')
			this.content.setAttribute('aria-hidden', 'false')
		}

		setCollapsedAria(el) {
			this.trigger.setAttribute('aria-expanded', 'false')
			this.content.setAttribute('aria-hidden', 'true')
		}

		attachEvents() {
			// Use bound handlers so they can be properly removed during destroy().
			if (this.trigger) {
				this._onTriggerClick = (event) => {
					// When user first clicks any trigger, remove default highlight from all items in the group (class + template data attribute)
					try {
						this._removeDefaultHoverFromGroup()
					} catch (e) { }
					this.toggle(event)
				}

				// When user moves pointer over a trigger, clear default-hover immediately
				this._onTriggerPointerEnter = (event) => {
					try { this._removeDefaultHoverFromGroup() } catch (e) { }
					// also remove any document-level first-user listeners created by ensureDefaultHover
					try {
						if (this._onFirstUserInteraction) {
							document.removeEventListener('click', this._onFirstUserInteraction, true)
							document.removeEventListener('touchstart', this._onFirstUserInteraction, true)
							this._onFirstUserInteraction = null
						}
						if (this._onFirstUserKeydown) {
							document.removeEventListener('keydown', this._onFirstUserKeydown, true)
							this._onFirstUserKeydown = null
						}
					} catch (e) { }
				}
				this.trigger.addEventListener("click", this._onTriggerClick)
				this.trigger.addEventListener("pointerenter", this._onTriggerPointerEnter)
			}
		}

		// Remove is-default-hover from this group (parent or document-wide)
		_removeDefaultHoverFromGroup() {
			try {
				const parent = this.closest('[data-collapsible-parent]') || document
				const items = parent === document ? Array.from(document.querySelectorAll('collapsible-tab')) : Array.from(parent.querySelectorAll('collapsible-tab'))
				items.forEach(item => {
					// remove helper classes
					try { if (item.trigger && item.trigger.classList) item.trigger.classList.remove('is-default-hover') } catch (e) { }
					try { const btnText = item.trigger && item.trigger.querySelector && item.trigger.querySelector('.collapsible__button-text'); if (btnText && btnText.classList) btnText.classList.remove('is-default-hover') } catch (e) { }
					try { if (item.classList) item.classList.remove('is-default-hover') } catch (e) { }
					// also remove the server/template-side marker so it no longer forces the style
					try { if (item.hasAttribute && item.hasAttribute('data-default-hover')) item.removeAttribute('data-default-hover') } catch (e) { }
					try { if (item.dataset && 'defaultHover' in item.dataset) { delete item.dataset.defaultHover } } catch (e) { }
				})
			} catch (e) { }
		}

		setDefaultData() {
			this.events = {
				'elementSelected': [],
				'tabOpened': [],
				'elementUnselected': [],
				'elementClosed': []
			}
			this.transitionendevent = this.transitionendEventName()
			this.expandedClass = "is-expanded"
			this.selectedClass = "is-selected"
			this.collapsedClass = "is-collapsed"
			this.trigger = this.querySelector('[data-trigger]')
			this.content = this.querySelector('[data-content]')
			// If template marked this item as default_hover, apply helper class immediately.
			try {
				if (this.hasAttribute && (this.hasAttribute('data-default-hover') || this.dataset.defaultHover === 'true')) {
					try { if (this.trigger && this.trigger.classList) this.trigger.classList.add('is-default-hover') } catch (e) { }
					try { const btnText = this.trigger && this.trigger.querySelector && this.trigger.querySelector('.collapsible__button-text'); if (btnText && btnText.classList) btnText.classList.add('is-default-hover') } catch (e) { }
					try { this.classList.add('is-default-hover') } catch (e) { }
				}
			} catch (e) { }
			this.collapsedHeight = '0px'
			this.defaultElements = ['a', 'button', 'input:not(.focus-none)', '[data-trigger]']
			this.oneAtATime = true
			if (this.dataset.oneOpen) {
				this.oneAtATime = this.dataset.oneOpen === 'true'
			}

			// Whether keep at least an item opened.
			// Changed: only allow closing all items if data-can-close-all="true" is explicitly set.
			// This way, by default, the last selected item is retained (clicking on empty space will not close all items).
			this.canCloseAll = (this.dataset.canCloseAll === 'true')
		}

		// Ensure the default hover class is applied in a timing-robust way.
		ensureDefaultHover() {
			try {
				const apply = () => {
					try { if (this.trigger && this.trigger.classList) this.trigger.classList.add('is-default-hover') } catch (e) { }
					try { const btnText = this.trigger && this.trigger.querySelector && this.trigger.querySelector('.collapsible__button-text'); if (btnText && btnText.classList) btnText.classList.add('is-default-hover') } catch (e) { }
					try { this.classList.add('is-default-hover') } catch (e) { }
				}

				// Try immediately
				apply()

				// If trigger/text not present yet, observe and also add a couple of fallbacks
				const needsTrigger = !(this.trigger && this.trigger.classList)
				const needsText = !(this.trigger && this.trigger.querySelector && this.trigger.querySelector('.collapsible__button-text'))
				if (needsTrigger || needsText) {
					let called = false
					let obs = null
					let timeoutId = null
					let onLoad = null

					const cleanup = () => {
						try { if (this._defaultHoverObserver) { this._defaultHoverObserver.disconnect(); this._defaultHoverObserver = null } } catch (e) { }
						try { if (this._defaultHoverOnLoad) { window.removeEventListener('load', this._defaultHoverOnLoad); this._defaultHoverOnLoad = null } } catch (e) { }
						try { if (this._defaultHoverTimeoutId) { clearTimeout(this._defaultHoverTimeoutId); this._defaultHoverTimeoutId = null } } catch (e) { }
						try { if (this._defaultHoverRetryId) { clearTimeout(this._defaultHoverRetryId); this._defaultHoverRetryId = null } } catch (e) { }
						try {
							if (this._onFirstUserInteraction) {
								document.removeEventListener('click', this._onFirstUserInteraction, true)
								document.removeEventListener('touchstart', this._onFirstUserInteraction, true)
								document.removeEventListener('keydown', this._onFirstUserKeydown, true)
								this._onFirstUserInteraction = null
								this._onFirstUserKeydown = null
							}
						} catch (e) { }
					}

					this._defaultHoverObserver = new MutationObserver(() => {
						try {
							if (!called) {
								apply()
								if ((this.trigger && this.trigger.classList) || (this.trigger && this.trigger.querySelector && this.trigger.querySelector('.collapsible__button-text'))) {
									called = true
									cleanup()
								}
							}
						} catch (e) { }
					})
					// Observe a sensible root: prefer the data-collapsible-parent if present, otherwise document.body
					try {
						const parentRoot = this.closest('[data-collapsible-parent]') || document.body || document
						this._defaultHoverObserver.observe(parentRoot, { childList: true, subtree: true })
					} catch (e) { }

					// window.load fallback: if resources finish loading later
					this._defaultHoverOnLoad = () => {
						try { apply() } catch (e) { }
						cleanup()
					}
					try { window.addEventListener('load', this._defaultHoverOnLoad) } catch (e) { }

					// safety timeout: stop observing after 2s and attempt one final apply
					this._defaultHoverTimeoutId = setTimeout(() => {
						try { apply() } catch (e) { }
						cleanup()
					}, 2000)

					// extra mid-time retry in case of microtask timing issues
					this._defaultHoverRetryId = setTimeout(() => { try { apply() } catch (e) { } }, 1200)

					// If the trigger might be created later, ensure any user interaction removes the helper class.
					if (!this._onFirstUserInteraction) {
						this._onFirstUserInteraction = (ev) => {
							try { this._removeDefaultHoverFromGroup() } catch (e) { }
							try { cleanup() } catch (e) { }
						}
						this._onFirstUserKeydown = (ev) => {
							if (!ev) return
							const k = ev.key || ev.keyIdentifier
							if (k === 'Enter' || k === ' ' || k === 'Spacebar') {
								try { this._removeDefaultHoverFromGroup() } catch (e) { }
								try { cleanup() } catch (e) { }
							}
						}
						document.addEventListener('click', this._onFirstUserInteraction, true)
						document.addEventListener('touchstart', this._onFirstUserInteraction, true)
						document.addEventListener('keydown', this._onFirstUserKeydown, true)
					}
				}
			} catch (e) { }
		}

		fire(eventName) {
			let callbacks = this.events[eventName] || []
			for (let i = 0; i < callbacks.length; i++) {
				callbacks[i](this)
			}
		}

		on(eventName, cb) {
			if (!this.events[eventName]) return
			this.events[eventName].push(cb)
		}

		destroy() {
			if (this.trigger && this._onTriggerClick) {
				this.trigger.removeEventListener("click", this._onTriggerClick)
				try { if (this._onTriggerPointerEnter) this.trigger.removeEventListener('pointerenter', this._onTriggerPointerEnter) } catch (e) { }
			}
			// cleanup any default-hover observers/listeners created by ensureDefaultHover
			try {
				if (this._defaultHoverObserver) { this._defaultHoverObserver.disconnect(); this._defaultHoverObserver = null }
			} catch (e) { }
			try { if (this._defaultHoverOnLoad) { window.removeEventListener('load', this._defaultHoverOnLoad); this._defaultHoverOnLoad = null } } catch (e) { }
			try { if (this._defaultHoverTimeoutId) { clearTimeout(this._defaultHoverTimeoutId); this._defaultHoverTimeoutId = null } } catch (e) { }
			try { if (this._defaultHoverRetryId) { clearTimeout(this._defaultHoverRetryId); this._defaultHoverRetryId = null } } catch (e) { }
			try {
				if (this._onFirstUserInteraction) {
					document.removeEventListener('click', this._onFirstUserInteraction, true)
					document.removeEventListener('touchstart', this._onFirstUserInteraction, true)
				}
				if (this._onFirstUserKeydown) {
					document.removeEventListener('keydown', this._onFirstUserKeydown, true)
				}
				this._onFirstUserInteraction = null
				this._onFirstUserKeydown = null
			} catch (e) { }
			this.content && this.content.removeAttribute('aria-hidden')
			if (this.content) this.content.style.height = 'auto'
			this.classList.remove(this.expandedClass, this.collapsedClass)
			this.removeAttribute('open')
		}
	}

	customElements.define('collapsible-tab', CollapsibleTab)
}

// Global safety: if for any reason instance-level cleanup didn't run,
// remove server-side marker and helper classes on the first user interaction.
// This is installed once per window and uses capture to run before other handlers.
if (!window.__collapsible_default_hover_global_installed) {
	const __removeAllDefaultHover = (ev) => {
		try {
			const items = Array.from(document.querySelectorAll('collapsible-tab'))
			items.forEach(item => {
				try { if (item.hasAttribute && item.hasAttribute('data-default-hover')) item.removeAttribute('data-default-hover') } catch (e) { }
				try { if (item.classList) item.classList.remove('is-default-hover') } catch (e) { }
				try { const triggerEl = item.querySelector && item.querySelector('[data-trigger]'); if (triggerEl && triggerEl.classList) triggerEl.classList.remove('is-default-hover') } catch (e) { }
				try { const btnText = item.querySelector && item.querySelector('.collapsible__button-text'); if (btnText && btnText.classList) btnText.classList.remove('is-default-hover') } catch (e) { }
				try { if (item.dataset && 'defaultHover' in item.dataset) { delete item.dataset.defaultHover } } catch (e) { }
			})
		} catch (e) { }
		try {
			document.removeEventListener('click', __removeAllDefaultHover, true)
			document.removeEventListener('touchstart', __removeAllDefaultHover, true)
			document.removeEventListener('keydown', __removeAllDefaultHover, true)
		} catch (e) { }
	}

	try {
		document.addEventListener('click', __removeAllDefaultHover, true)
		document.addEventListener('touchstart', __removeAllDefaultHover, true)
		document.addEventListener('keydown', __removeAllDefaultHover, true)
		window.__collapsible_default_hover_global_installed = true
	} catch (e) { }
}
